import { __assign, __extends } from "tslib";
import { getNative } from "../../../utils/Dom";
import Console from "./Console";
/**
 * Web console adapter
 */
var WebConsole = /** @class */ (function (_super) {
    __extends(WebConsole, _super);
    function WebConsole(config) {
        if (config === void 0) { config = {}; }
        return _super.call(this, __assign(__assign({}, config), { console: config.console || getNative("console") || window.console || null })) || this;
    }
    return WebConsole;
}(Console));
export default WebConsole;
//# sourceMappingURL=WebConsole.js.map